export default __webpack_public_path__ + "static/media/ic-camera-on.eba82a28.svg";